import React, { useEffect, useReducer, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, TableCell, TableRow, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Stack, Skeleton, IconButton, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRecoilState } from "recoil";
import { parksState } from "../../atoms/parks";
import { useNavigate } from "react-router-dom";
import { userState } from "../../atoms/user";
import axios from "axios";
import { CacheService } from "../../common/services/cache.service";
import environment from "../../environment/environment";
import APIOptions from "../../models/apiOptions";
import { Asset } from "../../models/asset";
import APIService from "../../services/api.service";
import { tokenState } from "../../atoms/token";

export function PendingTicDialog({row, handleApproveBtnClick, handleCancelClick}: {row: any, handleApproveBtnClick: any, handleCancelClick: any}) {
  const [ticStatus, setTicStatus] = useState(false);
  const [ticNum, setTicNum] = useState(null);

  const [parks, setParks] = useRecoilState(parksState);
  const [token, setToken] = useRecoilState(tokenState);

  const [form, setForm] = useReducer(
    (form, updates) => ({...form, ...updates}),
    {}
  );
  
  const infoTypes= [ {
    value: 'B',
    label: 'Boundary Survey',
  }, {
    value: 'D',
    label: 'D-TIC Document',
  },
  {
    value: "E-TIC Drawing",
    label: "E-TIC Drawing"
  }, {
    value: 'M',
    label: 'M-TIC Map',
  }
];

  useEffect(() => { 
    console.log('row', row);
    setForm(row);
  }, []);

  const handleChange = (fieldName: string, value: any) => {
    if(fieldName == 'parkName') { 
      let parkId = parks.find(x => x.name == value).id;
      setForm({'parkId': parkId});
      setForm({'parkName': value});
    }
    else 
      setForm({[fieldName]: value});
  }

  const renderTicSuccess = () => { 
    let code = parks.find(x => x.id ==form?.parkId).code;
    let alpha = parks.find(x => x.id ==form?.parkId).alpha;

    return (
      <>
        <h2>Congratulations! Here is the requested TIC Number:</h2>
        <h2 className="bold">Tic Number: {code}/{ticNum}</h2> 

        <h2 className="bold">Park Alpha: {alpha}</h2> 
        <h2 className="bold">Park Code: {code}</h2> 
        
      </>
    );
  }

  const handleApprove = () => { 
    //handleApproveBtnClick(form);
    const url = `${environment.eticApiUrl}UpdateRequestedTicNumber/${row.id}`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.add(form).then((res:any) => {
      console.log('approve res', res);
      const url = `${environment.eticApiUrl}UpdateRequestedTicNumber/${row.id}?action=approve`;
      const apiService = new APIService<any>(axios, new CacheService, url, token);

      apiService.getAnyAsync().then((res:any) => {
        setTicStatus(true); 
        setTicNum(res.ticNumber);
        console.log('approve res', res);
      });
    });
    
  }

  return (
    <div>
      <Dialog open={true}  PaperProps={{ style: { minWidth: "800px" } }}>
        <DialogTitle sx={{ fontWeight: "bolder" }}>Approve Tic Number</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "rgba(63, 66, 66, 0.76)", whiteSpace: "pre-line" }}>           
              <>
              {/* <h2>Approve Tic Number</h2> */}
            
            <form aria-disabled className="record-form">
              <Stack className="center" spacing={2} direction="column" sx={{marginBottom: 2}}>
                { ticStatus ?
                  <>
                    {renderTicSuccess()}
                  </>
                  :
                  <></>
                }
              </Stack>
  
              <Stack className="center" spacing={2} direction="column" sx={{marginBottom: 2}}>
                <TextField
                      type="text"
                      variant='outlined'
                      color='primary'
                      label="Park Name"
                      disabled={ticStatus || !parks.length}
                      onChange={e => handleChange('parkName', e.target.value)}
                      value={form?.parkName || ''}
                      sx={{width: 600}} 
                      size="small"
                      required
                      select>
                      {parks.map((option) => (
                        <MenuItem key={option.id} value={option.name}>
                          {option.name}
                        </MenuItem>
                      ))}
                </TextField>
  
                <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Info Type"
                    disabled={ticStatus}
                    onChange={e => handleChange('infoType', e.target.value)}
                    value={form?.infoType || ''}
                      InputLabelProps={{shrink: true}}
                    required
                    sx={{width: 600}} 
                    size="small"
                    select>
                      {infoTypes.map((option) => (
                        <MenuItem key={option.value} value={option.label}>
                          {option.label}
                        </MenuItem>
                      ))}
                </TextField>
  
                <TextField
                      type="text"
                      variant='outlined'
                      color='secondary'
                      label="Title"
                      disabled={ticStatus}
                      onChange={e => handleChange('title', e.target.value)}
                      value={form?.title}
                      sx={{width: 600}} 
                      size="small"
                      required
                      InputLabelProps={{shrink: true}}
                />
          
                <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="PMIS #"
                    disabled={ticStatus}
                    onChange={e => handleChange('pmisNumber', e.target.value)}
                    value={form?.pmisNumber}
                    sx={{width: 600}} 
                    size="small"
                />
  
                <TextField
                  disabled={ticStatus}
                  type="text"
                  variant='outlined'
                  color='secondary'
                  label="Comments"
                  onChange={e => handleChange('comments', e.target.value)}
                  value={form?.comments}
                  fullWidth
                  sx={{width: 600}}
                  size="medium"
                  inputProps={{maxLength: 1000}}
                />
              </Stack>
            </form>
              </>         
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            id="cancel" 
            variant="outlined" 
            startIcon={<FontAwesomeIcon icon={["fas", "arrow-left"]} />}
            onClick={handleCancelClick}>
              Back
          </Button>

 
          { !ticStatus &&
            <Button
              id="secondary" 
              variant="outlined" 
              startIcon={<FontAwesomeIcon icon={["fas", "save"]} />}
              onClick={handleApprove}>
                Approve
            </Button>
          }
          
        </DialogActions>
      </Dialog>
    </div>
  );
}
